

// Font size extension (JS port of the TS version)
// Wires into our ActionMenuButtonMenu/exts/FontSizeActionMenuButton.vue

import { Extension } from '@tiptap/core'

// If you have app-level constants, swap these with imports.
const DEFAULT_FONT_SIZE_LIST = [12, 14, 16, 18, 20, 24, 28, 32]

// Utility: ensure a CSS unit (default px if none)
function getCssUnitWithDefault(val) {
  if (val == null) return ''
  const s = String(val).trim()
  if (/^(\d+(?:\.\d+)?)(px|em|rem|%)$/.test(s)) return s
  if (/^\d+(?:\.\d+)?$/.test(s)) return `${s}px`
  return s
}

// Lazy import path note: our action menu button lives under ActionMenuButtonMenu
import { FontSizeActionMenuButton } from '@/tiptap/extensions/components/ActionMenuButton'

export const FontSize = Extension.create({
  name: 'fontSize',

  addOptions() {
    // `types` determines which nodes/marks carry the global attribute
    return {
      ...(this.parent?.() || {}),
      types: ['textStyle'],
      fontSizes: [...DEFAULT_FONT_SIZE_LIST],
      button: ({ editor, extension, t }) => ({
        component: FontSizeActionMenuButton,
        componentProps: { editor, extension, t }
      })
    }
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            parseHTML: element => {
              const raw = element.style.fontSize || ''
              const m = raw.match(/^(\d+(?:\.\d+)?)(px|em|rem|%)?$/)
              return m ? m[0] : ''
            },
            renderHTML: attrs => {
              if (!attrs.fontSize) return {}
              return { style: `font-size: ${getCssUnitWithDefault(attrs.fontSize)}` }
            }
          }
        }
      }
    ]
  },

  addCommands() {
    return {
      setFontSize:
        fontSize => ({ chain }) =>
          chain().setMark('textStyle', { fontSize }).run(),

      unsetFontSize:
        () => ({ chain }) =>
          chain().setMark('textStyle', { fontSize: null }).removeEmptyTextStyle().run()
    }
  }
})

export default FontSize